import { HandlerList } from "./HandlerList"

export default function ResponseHandler(statusCode: number, prefix: string) {
  const HandlerListKeys = Object.keys(HandlerList)
  if( HandlerListKeys.includes(prefix) ) {
    const _match = HandlerList[prefix].match;
    const _default = HandlerList[prefix].default;

    const matchKeys = Object.keys(_match);
    if( matchKeys.includes(statusCode.toString()) ) {
      return HandlerList[prefix].match[statusCode.toString()];
    }
    else {
      return _default;
    }

  } else {
    return HandlerList.default
  }

}
